<script setup>
  import { ref, computed, useTemplateRef, onMounted, onErrorCaptured } from 'vue';
  import { useProForecastStore } from '@/stores/ProForecastStore';
  import FooterBannerAd from "@/components/FooterBannerAd.vue";  
  import ProForecast from '@/components/ProForecast.vue';
  import ErrorBlock from '@/components/ErrorBlock.vue';
  import useContainerConfigurationGlobals from '@/composables/useContainerConfigurationGlobals';
  import useAdConfigurationGlobals from '@/composables/useAdConfigurationGlobals';
  import useSettingsGlobals from '@/composables/useSettingsGlobals';

  const proForecastContainer = useTemplateRef('pro-forecast-container');

  const { $PRO_FORECAST } = useContainerConfigurationGlobals();
  const { $ADS_ALLOWED } = useAdConfigurationGlobals(); 
  const { $WEB_VIEW } = useSettingsGlobals();

  const proForecastStore = useProForecastStore();

  await proForecastStore.getProForecast($PRO_FORECAST.pro_forecast_id);
  await proForecastStore.getForecasters();

  const loadFooterAd = ref(false);
  const error = ref(null);

  const showFooterBannerAd = computed(() => $ADS_ALLOWED && $WEB_VIEW && loadFooterAd.value);

  onMounted(() => {
    loadFooterAd.value = true;

  });

  onErrorCaptured((e) => {
    console.warn(e);

    error.value = { 
      title: `There was a problem loading the Pro Forecast (${$PRO_FORECAST.pro_forecast_id})`,
      message: `Please try again later.`,
      errorText: e.message
    }

    console.warn('There was an error retrieving the Pro Forecast.', e);

    return false;
  })  
</script>

<template>
  <ErrorBlock v-if="error" :error="error" />
  <ProForecast ref="pro-forecast-container" v-else />
  <FooterBannerAd
    v-if="showFooterBannerAd"
    :refreshOnClick="true"
    :refreshOnScroll="true"
    :scrollTarget="proForecastContainer"
    :mobileOnly="false"
  />  
</template>